export enum TimeoutValues {
  SESSION_TIME = 14400000, // 4 hours
  DISPLAY_ALERT_TIME = 300000, // 5 minutes
  OFFSET = 1500, // 1.5 seconds
  CHANGE_COLOR_TIME = 10000, // 10 seconds
}
